import { FC } from "react";

import { Box, SxProps, Theme } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";
import { mergeSx } from "@/helpers/mergeSx";
import { Zeffy as ZeffyLogo } from "@/icons/other";

type ThemedFormZeffyLogoProps = {
  href: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

export const ThemedFormZeffyLogo: FC<ThemedFormZeffyLogoProps> = ({ href, sx, ...rest }) => {
  const { logoColor } = useDynamicThemeAwareVariables(({ formsPalette, mode }) => ({
    logoColor: mode === "light" ? formsPalette.surface.moderate : formsPalette.surface.supershy,
  }));

  return (
    <Box
      display="inline-block"
      width={{ xs: 66, md: 100 }}
      height={{ xs: 20, md: 30 }}
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={mergeSx(
        {
          color: logoColor,
          textDecoration: "none",
          cursor: "pointer",
          ["&:hover"]: {
            color: logoColor,
            opacity: 0.8,
          },
        },
        sx
      )}
      data-test="zeffy-logo-wrapper"
      {...rest}
    >
      <ZeffyLogo width="100%" height="100%" fill="currentColor" />
    </Box>
  );
};
